import {Component} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {BisherigeAdresse} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'common-ui-bisherige-adresse',
  templateUrl: './bisherige-adresse.component.html'
})
export class BisherigeAdresseComponent
  extends FormBaseComponent<BisherigeAdresse> {

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService,
              protected readonly translateService: TranslateService) {
    super(messageService);
  }

  public get getOrtLocalization() {
    return this.translateService.instant('COMMON_UI.FRAGEBOGEN.BISHERIGEPERSOENLICHEVERHAELTNISSE.ZUGEZOGEN.ORT');
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      zugezogenAm: [this.data.zugezogenAm, [
        this.validatorService.required(),
        this.validatorService.date()
      ]]
    });
  }
}
